
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useDuplicateItemTranslate } from '@/modules/duplicate/item/model/translate';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.ITEM.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, beforeFetch, actions, localeSupportedOptions } = useDuplicateItemTranslate();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
